import NotificationType from '../NotificationType';

export default class SubRequestResponseReceived extends NotificationType {
  get icon() {
    return 'fa-solid fa-reply';
  }

  resolveRoute(notification) {
    const eventFormId = notification.params?.event_form_id;
    const subRequestId = notification.params?.sub_request_id;
    if (!eventFormId) return null;
    if (!subRequestId) return { name: 'admin-event-form-show', params: { id: eventFormId } };

    return {
      name: 'admin-event-form-sub-request-show',
      params: { eventFormId, id: subRequestId },
    };
  }
}
